var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_251_966)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_251_966",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_251_966",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_251_966",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCElEQVR4nO2dv2oUURSHv4C6QSs1ha4BQS0sk0pFUItUPoOPEJPO9RG0EBWtBa0UQTsb/5SuQWG1sNAnUKxi0izqXhm4RRTdvXd2ds6dO78PTrU798x8HM5Mzkx2QAghhBCiScwD68AGsA24hsc28AZYAzokwiLwIQE5bkbx3h+jeSXnLNntkG1a2esJSHA1xWVL0RsJCHA1Rd9S9FYCAlxNURyrGa5lYYb1gTuJtpfiVNH8IeEZcAk4BuzzcQ54lYDYLFrHJnBxzNpzwIME5DZa9A/gbMD6u4CTwP0EJDdS9I0SuR5JdJzkX8DREqKPAyNVdLjoAeUptlXrCJRwbwrRDyU6vNKuTSH6pkSHi74+hehiW7WOQAmPpxBtfeVhRpmd/QbsLpGruKb+KtHhoj/6OzOxzPttVdGBEu5QnrsRoofAFaA7Zr3is57/bnat4/kU+V5E5CkEhtLLUfRPYKVErhW/bWiecZX8N90cRTsv7GBEnv2RkmNFH8lVtANWI/Ksllg/pnVczVn0F2AhIMeC/27s+kMvu7UnQ7cjipPb3jHrF5+9rCBPVWFGFTt/Ycz65xOQK9FIdFSVnB5T0acSqOIsKrrvb8L+j7nEHjszo+wOj4AnwIGAHMX19tMEbmM1SvTIS1sukWs5UnhrZx2fJvTjUM4AnwPytXLW8db/GV0VxVrvJuRs3azju39UoGpOTHhsuHWib80w/+2KWkcWs46lGeZfmnAy1KyDZoYZ1gfuJNpeilNFYy5MrYO0Qz0aiTavQlU09uLUOrCX2rgePQwYV1qR1Zi0R/pkMSY9TPocykF0l/TJ4pGwHumTxZh0GDCutCKrk6HLKCQaiTavQlU09uLUOrCXqh6NRP+zCoaaddRzedcjfTTrqAnNOmpCs46a0KxjxmjWgf01s66jkWjzinOqaMwlqXVgL1A9mrTCjDb99PympeiU/qvV5fwyhbUEBLiaIuaHXCqn418G4zKPAbAHYxYzlz3wQ6ck6Pg37/QzOUFuAa99uzCvZCGEEEIIgvkNhv8mDXL4B1UAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume_icon.ef90acc7e791ecd2cbd99bb0ab55e20d.svg";
export { ForwardRef as ReactComponent };